export default function (state, getters, rootState, rootGetters) {
  let form = state.form;
  let system = state.system;
  let operationType = getters.computed_operationType;
  let ags = [];
  let data = {};
  if (!form.ContragentID || !form.Sum) return;
  data.PaymentDirection = form.PaymentDirection;
  data.Direction = form.PaymentDirection + 1;
  data.PaymentOperationID = form.PaymentOperationID;
  data.PaymentTypeId = form.PaymentTypeId;
  data.ContragentType = form.ContragentType;
  data.ContragentID = form.ContragentID;
  if (!form.ContragentID) {
    window.app.$notify.warning({
      message: 'Необходимо указать контрагента',
    });
    return;
  }
  data.Sum = form.Sum;
  if (form.Sum < getters['agreements/sum_all']) {
    window.app.$notify.warning({
      message: 'Размер оплаты меньше суммы распределеной по путевкам',
    });
    return;
  }
  data.CurrencyId = form.CurrencyId;
  data.SumVat = form.SumVat;

  data.BankCommission = form.commission;
  data.Comment = (form.Comment);
  if (form.PaymentDirection === 1) {
    data.RateArticleId = form.RateArticleId;
  }
  if (form.ContragentType === 2 || form.ContragentType === 3 || form.ContragentType === 6 || form.ContragentType === 7) {
    data.PartnerLegalEntityId = form.PartnerLegalEntityId;
  }

  switch (form.CategoryId) {
    case 0:
      data.CashId = form.CashId;
      break;
    case 1:
      data.PaymentAccountId = form.PaymentAccountId;
      break;
  }
  if (operationType) {
    data.AccountNumber = (form.AccountNumber);
    form.AgreementCodes.forEach(i => {
      ags.push(getters['agreements/agreement'](i));
    });
    data.PaymentDetails = [];
    let error = false;
    ags.forEach(i => {
      let item = {};
      item.Code = (i.code);
      item.Comment = (i.comment);
      item.Course = i.course;
      item.CarryOverOfFunds = i.CarryOverOfFunds;
      if (i.currency !== form.CurrencyId) {
        if (!i.course || i.course === 1) {
          window.app.$notify.warning({
            title: 'Введите курс',
            message: 'Детализация путевки: ' + i.code,
          });
          error = true;
          return;
        }
      }
      item.TargetCurrencyId = 0;
      item.Spread = 0;
      if (form.ContragentType === 3) item.OrderPrices = [];
      item.Date = {Serialized: i.date, Format: "dd.MM.yyyy"};
      i.requests.forEach(j => {
        item.Course = (j.currency !== data.CurrencyId && form.CategoryId !== 2) ? i.course : 1;
        item.TargetCurrencyId = j.currency;
        item.Spread += Math.round(item.Course * j.sum * 100) / 100;
        if (form.ContragentType === 3) {
          item.OrderPrices.push({
            RequestId: (j.value),
            Spread: Math.round(item.Course * j.sum * 100) / 100,
          });
        }
      });
      if (item.Spread) data.PaymentDetails.push(item);
    });
    if (error) return '';
  }
  data.PaymentFor = (form.PaymentFor);
  switch (system.type) {
    case 'pay':
      data.BankCommission = form.BankCommission || 0;
      if (form.Id) data.Id = form.Id;
      if (form.CertificateId) data.CertificateId = form.CertificateId;
      data.DocumentNumber = (form.DocumentNumber);
      data.PaymentDate = {"Serialized": form.PaymentDate, "Format": "dd.MM.yyyy"};
      let RegularPayments = [];
      state.regulars.list.forEach(i => {
        RegularPayments.push({
          RegularPaymentId: i.value,
          Spread: i.sum,
        });
      });
      if (RegularPayments.length) data.RegularPayments = RegularPayments;

      break;
    case 'regular':
      if (form.RegularPaymentId) {
        data.Id = form.RegularPaymentId;
        data.RegularPaymentId = form.RegularPaymentId;
      }
      data.Name = (form.Name);
      data.NameLat = (form.NameLat);
      data.RegularPaymentTypeId = form.RegularPaymentTypeId;
      data.Notify = false;
      switch (form.RegularPaymentTypeId) {
        case 0:
          data.PaymentDay = form.dayMonth;
          break;
        case 1:
          data.PaymentDay = form.dayWeek;
          break;
        case 3:
          data.PaymentDate = {Serialized: form.dayYear};
          break;
        case 4:
          data.PaymentDate = {Serialized: form.dayOne};
          break;
      }
      if (form.NotificationsEndDate) data.NotificationsEndDate = {Serialized: form.NotificationsEndDate};
      data.Invoices = [];
      state.invoices.list.forEach(i => {
        data.Invoices.push({
          RegularPaymentId: i.value,
          Spread: i.sum,
        });
      });
      break;
    case 'invoice':
      if (form.Id) data.Id = form.Id;
      data.Name = form.Name;
      data.NameLat = form.NameLat;
      data.NeedToPayDate = {Serialized: form.NeedToPayDate};
      data.AccountDate = {Serialized: form.AccountDate};
      data.CreatedDate = {Serialized: form.CreatedDate};
      break;
  }
  return data;
}
